export const noDataProductUsage = ['plot1d', 'plot2d', 'time_series', 'white_light', 'coronagraphs', 'euv', 'euv_comparison'];

export const noVariableUsage = ['white_light', 'coronagraphs', 'euv', 'euv_comparison', 'data_products'];

export const noDomainUsage = ['data_products', 'spacecraft_mapping', 'euv', 'euv_comparison', 'coronagraphs'];

export const vectorVariables = ['br', 'bt', 'bp', 'jr', 'jt', 'jp', 'vt', 'vp']

export const vectorColormaps = ['PiYG', 'PRGn', 'BrBG', 'PuOr', 'RdGy', 'RdBu', 'RdYlBu', 'RdYlGn', 'Spectral',
  'coolwarm', 'bwr', 'seismic', 'psi_seismic', 'psi_blue_red', 'psi_aqua_crimson_dark', 'psi_aqua_crimson',]

export const radScaleVariables = ['br', 'bt', 'bp', 'jr', 'jt', 'jp', 'rho', 'em', 'ep']

export const logScaleVariables = ['rho', 'em', 'ep', 't']

export const hasAsciiTable = ['spacecraft_mapping', 'time_series']

export const debounceInterval = 200;

export const throttleCount = 3;

export const PARAMETER_SCHEMA = {
  sim_widget: {},
  slice_widget: {},
  point_widget: {},
  view_widget: {},
  obs_widget: {},
  plot_widget: {}
}

export const toolExtensionCoupling = {
  plot1d: 'HDF',
  plot2d: 'HDF',
  data_products: 'HDF',
  spacecraft_mapping: 'ECSV',
  time_series: 'ECSV',
  white_light: 'FITS',
  coronagraphs: 'FITS',
  euv: 'FITS',
  euv_comparison: 'FITS',
}

export const toolTutorialLinks = {
  masdb: 'https://www.youtube.com/watch?v=i0vzg-ufBjE&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=1',
  plot1d: 'https://www.youtube.com/watch?v=198WFWn475A&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=2',
  plot2d: 'https://www.youtube.com/watch?v=Cb9a7wsDgtU&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=3',
  data_products: 'https://www.youtube.com/watch?v=T8KxrBN4P4o&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=4',
  time_series: 'https://www.youtube.com/watch?v=d3cc7AwBM0s&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=5',
  spacecraft_mapping: 'https://www.youtube.com/watch?v=gk3vtkE3Rcs&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=6',
  white_light: 'https://www.youtube.com/watch?v=T32mu5QeKHk&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=7',
  coronagraphs: 'https://www.youtube.com/watch?v=5WaVni-BxOg&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=8',
  euv: 'https://www.youtube.com/watch?v=5mAq4Ik5CvA&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=9',
  euv_comparison: 'https://www.youtube.com/watch?v=f1AAr7Iegjc&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=10',
  data_access: 'https://www.youtube.com/watch?v=5XM4Pc5dS-M&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=11',
  demonstration: 'https://www.youtube.com/watch?v=aaqg3tcoVwY&list=PLFMyiu2nqQCPsmFzsntGEfZOdB7TR03Fq&index=12'
}
